import { RootState } from '../types'
import { ActionTree, ActionContext } from 'vuex'
import { AccountState } from './types'
import axios, { AxiosResponse } from 'axios'

import { apiUrl, adapter } from '../adapter'

export const actions: ActionTree<AccountState, RootState> = {

  register (store: ActionContext<AccountState, RootState>, payload:
    {
      username: string; email: string; password1: string; password2: string; name: string; courses: number[]; grade: string; year: number;
    }): Promise<void> {
    return adapter.postRequest('/customauth/registration/', payload, false, { withCredentials: true })
  },
  verifyEmail (store: ActionContext<AccountState, RootState>, verifyToken): Promise<{}> {
    return adapter.postRequest('/rest-auth/registration/verify-email/', {
      key: verifyToken
    }, false, { withCredentials: true })
  },
  resetPassword (store: ActionContext<AccountState, RootState>, email: string): Promise<{}> {
    return adapter.postRequest('/rest-auth/password/reset/', { email }, false, { withCredentials: true })
  },
  /* eslint-disable */
  changePassword (store: ActionContext<AccountState, RootState>, payload: { token: string; uidb64: string; newPassword: string }): Promise<{}> {
    return adapter.postRequest('/rest-auth/password/reset/confirm/', {
      token: payload.token,
      uid: payload.uidb64,
      'new_password1': payload.newPassword,
      'new_password2': payload.newPassword
    }, false, { withCredentials: true })
  },
  /* eslint-enable */
  userExists (store: ActionContext<AccountState, RootState>, email): Promise<{}> {
    return adapter.getRequest('/customauth/user-exists/', {
      email
    }, false, false, { withCredentials: true })
  },
  login (store: ActionContext<AccountState, RootState>, payload: { username: string; password: string }): Promise<{}> {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + '/rest-auth/login/', {
        username: payload.username,
        password: payload.password
      }, {
        withCredentials: false,
        headers: {
        }
      })
        .then((response: AxiosResponse) => {
          store.commit('LOGIN',
            {
              token: response.data.key,
              userName: payload.username
            })
          store.dispatch('userInfo')
          resolve()
        }).catch((error) => {
          reject(error)
        })
    })
  },
  userInfo (store: ActionContext<AccountState, RootState>): Promise<void> {
    return adapter.getRequest('/customauth/user-info/', {}, true).then((response) => {
      store.commit('SET_USER_INFO', response)
    })
  },
  // Grades & Courses
  changeGradeAndCoursesAndBooks (store: ActionContext<AccountState, RootState>, payload: {
    courses: number[]; grade: string; year: number; books: { book: number; course: number }[];
  }): Promise<{}> {
    return adapter.postRequest('/customauth/change-grade-and-courses-and-books/', payload, true).then(() => store.dispatch('userInfo'))
  },
  // Favorites
  favorites (store: ActionContext<AccountState, RootState>): Promise<void> {
    return adapter.getRequest('/customauth/favorites/', {}, true).then((response) => {
      store.commit('SET_FAVORITES', response)
    })
  },
  addFavorite (store: ActionContext<AccountState, RootState>, payload: { book: number; category: number; content: number }): Promise<void> {
    return adapter.postRequest('/customauth/favorites/', payload, true).then((response) => {
      store.commit('ADD_FAVORITE', response)
    })
  },
  removeFavorite (store: ActionContext<AccountState, RootState>, id: number): Promise<void> {
    return adapter.deleteRequest('/customauth/favorites/', { id: id.toString() }, true).then(() => {
      store.commit('REMOVE_FAVORITE', id)
    })
  }
}
